import { render } from "./SplitOffModal.vue?vue&type=template&id=f8bdb5c6&scoped=true"
import script from "./SplitOffModal.vue?vue&type=script&lang=js"
export * from "./SplitOffModal.vue?vue&type=script&lang=js"

import "./SplitOffModal.vue?vue&type=style&index=0&id=f8bdb5c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8bdb5c6"]])

export default __exports__